import {
  ADICIONAR_FILTRO_AGENDAMENTO_VIAGEM,
   LISTAR_FILTROS_AGENDAMENTO_VIAGEM,
  REMOVER_FILTRO_AGENDAMENTO_VIAGEM,
} from '../../actions/types'
import {filtroExiste} from '../../util/filtros'

const initialState = undefined

const initial = {
}

export const filtrosAdicionadosAgendamentoViagem = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_AGENDAMENTO_VIAGEM: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_AGENDAMENTO_VIAGEM: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    default:
      return state
  }
}

export const filtrosAgendamentoViagem = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_AGENDAMENTO_VIAGEM: {
      return action.payload.data
    }
    default:
      return state
  }
}
